import { FC } from "react";

import { useAppSelector } from "../../../../../../hook/useAppSelector";
import { useAppDispatch } from "../../../../../../hook/useAppDispatch";

import {
  clearAutocompleteList,
  setSearchInput,
} from "../../../../../../store/slice/health-monitor/device-list";
import store from "../../../../../../store/store";

import { loadDeviceList } from "../../../../../../util/route/loader/load-device-list";

interface Props {
  handleShouldRefreshDeviceListOnClear: (shouldRefresh: boolean) => void;
}

const AutocompleteDropdown: FC<Props> = ({
  handleShouldRefreshDeviceListOnClear,
}) => {
  const autocompleteList = useAppSelector(
    (state) => state.deviceList.autocompleteList
  );
  const dispatch = useAppDispatch();

  const highlightMatch = (elementFromList: string) => {
    const startingIndex = elementFromList
      .toLowerCase()
      .indexOf(store.getState().deviceList.searchInput?.toLowerCase()!);
    const endingIndex =
      startingIndex + store.getState().deviceList.searchInput?.length!;

    const firstPart = elementFromList.slice(0, startingIndex);
    const secondPart = elementFromList.slice(startingIndex, endingIndex);
    const thirdPart = elementFromList.slice(endingIndex);

    return (
      <>
        {firstPart}
        <strong>{secondPart}</strong>
        {thirdPart}
      </>
    );
  };

  return (
    <>
      {autocompleteList && autocompleteList.length > 0 && (
        <ul>
          {autocompleteList.map((elementFromList, key) => (
            <li
              key={`${elementFromList}_key${key}`}
              onClick={() => {
                dispatch(clearAutocompleteList());
                dispatch(setSearchInput(elementFromList));
                handleShouldRefreshDeviceListOnClear(true);
                loadDeviceList();
              }}
            >
              {highlightMatch(elementFromList)}
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default AutocompleteDropdown;
